import { render, staticRenderFns } from "./ItemNot.vue?vue&type=template&id=6ea07470&scoped=true&"
import script from "./ItemNot.vue?vue&type=script&lang=js&"
export * from "./ItemNot.vue?vue&type=script&lang=js&"
import style0 from "./ItemNot.vue?vue&type=style&index=0&id=6ea07470&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea07470",
  null
  
)

export default component.exports